<template>
  <div
    class="people_wrap dialog-app-panel"
    :class="showPeoplePanel ? 'dialog-show' : ''"
  >
    <appPanel
      class="app-panel"
      :width="770"
      :isExpand="showPeoplePanel"
      title="选择人员"
      @cancel="handleClosePeoplePanel"
    >
      <div class="choose-people">
        <div v-for="(item, index) in checkPeople" class="people" :key="index">
          <el-tag size="small" @close="handleCloseTag(item)" closable>{{
            item.personName
          }}</el-tag>
        </div>
      </div>
      <ioc-table
        ref="multipleTable"
        :data="tableData"
        :option="constData.peopleTable"
        :page="constData.page"
        @selection-change="handleSelectionChange"
        @search-change="handleSearchChange"
        @search-reset="handleSearchReset"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </ioc-table>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleClosePeoplePanel"
          type="info"
          :loading="subLoading"
        >
          {{ subLoading ? "提交中" : "取消" }}
        </el-button>
        <el-button
          type="primary"
          :loading="subLoading"
          @click="handleSavePeoplePanel"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index";
import utils from "@src/common/utils";
import { peopleTable } from "../config/peopleTable";
export default {
  components: {
    appPanel,
  },
  props: {
    groupCode: {
      type: String,
      default: "",
    },
    showPeoplePanel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showPeoplePanel: {
      handler(val) {
        if (val) {
          this.constData.page.pageNum = 1;
          this.constData.page.pageSize =
            utils.Cache.get("CURRENT_PAGESIZE") || 10;
          this.getPeople();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      constData: {
        peopleTable: peopleTable(true, true),
        page: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        searchForm: {},
      },
      tableData: [],
      checkPeople: [],
      subLoading: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleClosePeoplePanel(type = false) {
      this.checkPeople = [];
      this.$emit("handleClosePeoplePanel", type);
    },
    getPeople() {
      let params = {
        ...this.constData.page,
        ...this.constData.searchForm,
        thirdRightGroupCode: this.groupCode,
      };
      this.$fetch(api.getPeople, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.tableData = res.returnObj.list;
        console.log(this.tableData);
        this.constData.page.total = res.returnObj.total;
      });
    },
    handleSavePeoplePanel() {
      if (!this.checkPeople.length) {
        this.$message.warning("请选择人员");
        return;
      }
      let params = {
        personnelCodeList: this.checkPeople.map((el) => {
          return el.personnelCode;
        }),
        thirdRightGroupCodeList: [this.groupCode],
      };
      this.subLoading = true;
      this.$fetch(api.addAuthority, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.handleClosePeoplePanel(true);
        } else {
          this.$message.error(res.msgContent || "添加失败");
        }
        //
      });
    },
    handleSearchChange(param) {
      this.constData.page.pageNum = 1;
      this.constData.searchForm = Object.assign({}, param);
      this.getPeople();
    },
    // 条件重置
    handleSearchReset() {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = 10;
      this.constData.searchForm = {};
      this.getPeople();
    },
    // 分页查询
    handleCurrentChange(val) {
      this.constData.page.pageNum = val;
      this.getPeople();
    },
    // 条数查询
    handleSizeChange(val) {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = val;
      this.getPeople();
    },
    // 多选
    handleSelectionChange(row) {
      this.checkPeople = [...row];
    },
    handleCloseTag(item) {
      this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(
        item,
        false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.people_wrap {
  width: 100%;
  height: 100%;
  .choose-people {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;
    .people {
      margin: 0px 5px 5px;
    }
  }
}
</style>